import { render, staticRenderFns } from "./InstantMeetingsConfiguration.vue?vue&type=template&id=9fb42664&scoped=true&"
import script from "./InstantMeetingsConfiguration.vue?vue&type=script&lang=ts&"
export * from "./InstantMeetingsConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb42664",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VForm,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fb42664')) {
      api.createRecord('9fb42664', component.options)
    } else {
      api.reload('9fb42664', component.options)
    }
    module.hot.accept("./InstantMeetingsConfiguration.vue?vue&type=template&id=9fb42664&scoped=true&", function () {
      api.rerender('9fb42664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/InstantMeetingsConfiguration.vue"
export default component.exports